module.exports = __webpack_public_path__ + "static/media/2_en.c95e6e92.png";